import React, { Component, memo, useMemo } from 'react'
import moment from 'moment'
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { connect } from "react-redux"
import * as actions from "../../../../actions/actions"
//img
import Lock from '../../../../images/updatepopup/openLock.svg'
import caretLeft from '../../../../images/general/caret-left.svg'
import caretRight from '../../../../images/general/caret-right.svg'
import Arrow from '../../../../images/general/white-arrow.svg'
import Warning from '../../../../images/general/warning-sign.svg'
import circleAdd from '../../../../images/general/circle-add.svg'
//icons
import { SvgIcon } from '@material-ui/core';
import EventIcon from '@material-ui/icons/Event';
import ParallelIcon from '../../../../images/updatepopup/parallel.svg'
import problem_icon from "../../../../images/general/problem.svg";
import { sortProcessesMonthlyRView, sortProcessesMonthlyView } from '../../../../functions/data/sortProcesses'
import { createOrderProcessForM_RBackground } from '../../../../functions/helpers/createOrderProcessBackground'
import { InformationPopup } from '../../../updatePopups/InformationPopup';
import drag_icon from '../../../../images/icons/drag_x.svg'
import { padStart } from 'lodash';
import { getPosition, updateClass } from '../../../../hooks/helper';
import memoizeOne from 'memoize-one';
let uniqid = require("uniqid");

const memoSortMonthlyRView = memoizeOne((date, data) =>
    sortProcessesMonthlyRView(date, data)
);

const STYLE_RESOURCE_SECTION_PADDING = { padding: '0px 10px' }
const STYLE_PARALLEL_ICON_ABSOLUTE = { marginBottom: '2px', position: 'absolute', left: '10px' }
const STYLE_DAY_OFF_P = { width: '100%' }

const ProcessItem = memo(({
    data,
    day,
    userIndex,
    Index,
    i,
    disableDrag,
    user_or_order_type,
    isCurrentProcess,
    handleProcessMenu,
    shouldRenderProcessOnThisDay,
    checkIndexAt,
    checkIndexAndSetWidth,
    getProcessBorderRadius,
    initHandlerForInfoPopup,
    closeHandlerInfoPopup
}) => {
    const resourcesString = useMemo(() => {
        return data?.proccess?.resource?.reduce((acc, item) => {
            return acc ? `${acc} / ${item.name}` : item.name
        }, '') || ''
    }, [data?.proccess?.resource])

    const processStyle = {
        cursor: data?.proccess?.fraction ? 'pointer' : '',
        borderRadius: getProcessBorderRadius(data?.proccess),
        backgroundColor: createOrderProcessForM_RBackground(data, user_or_order_type),
        zIndex: checkIndexAt(day.parsedDate, data) ? '99' : '0',
        visibility: !data.proccess.currentProcess && isCurrentProcess ? 'hidden' : '',
        height: !data.proccess.currentProcess && isCurrentProcess ? '0px' : '',
        width: !data.proccess.currentProcess && isCurrentProcess
            ? '0px'
            : checkIndexAndSetWidth(0, data),
        margin: !data.proccess.currentProcess && isCurrentProcess ? '0px' : '',
        border: !data.proccess.currentProcess && isCurrentProcess ? '0px' : '',
    };

    const infoPopupStyle = useMemo(() => ({
        display: 'none',
        transform: `translateX(${getPosition({ initial: -10, last: 100 }, data?.proccess?.process_date)}%)`
    }), [data?.proccess?.process_date])

    if (!shouldRenderProcessOnThisDay(data.proccess, day.date)) return null
    if (!data || !data.proccess || data.proccess.backlog) return null

    if (data?.proccess?.isSegment) {
        return <div key={data.proccess._id} style={{ height: '38px', marginBottom: '2px' }} />
    }

    const info_popup_position = { initial: -10, last: 100 }

    if (!data.proccess.currentProcess && isCurrentProcess) return null

    return (
        <Draggable
            draggableId={data.proccess._id + '_' + userIndex + '_' + Index + '_' + (data.proccess?.resource[0]?.resource_id)}
            index={i}
            key={`${data.proccess._id}_${Index}`}
            isDragDisabled={disableDrag || data.proccess.done || data.proccess.fraction}
        >
            {(provided) => (
                <React.Fragment>
                    <div
                        onClick={() => handleProcessMenu(data, day.date)}
                        className={data?.warnings ?
                            `month-resource-page__calendar__table__day__process month-resource-page__calendar__table__day__process--warning ${updateClass(data.proccess)}` :
                            `month-resource-page__calendar__table__day__process ${updateClass(data.proccess)}`
                        }
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                        style={{ ...processStyle, ...provided.draggableProps.style }}
                        id={`${data.proccess._id}x1y2`}
                    >
                        <div
                            className="drag__icon__container"
                            onMouseEnter={(event) => initHandlerForInfoPopup(event, data.proccess._id)}
                            onMouseLeave={(event) => closeHandlerInfoPopup(event, data.proccess._id)}
                        >
                            <img className="drag__icon" src={drag_icon} alt="drag icon" />
                        </div>
                        <section className="resource-section" style={STYLE_RESOURCE_SECTION_PADDING}>
                            <div>{data.order_number} - {data.client_name}</div>
                            <div tooltip={resourcesString}>
                                <p>{data?.proccess?.process_name} - <span className="month__proccess__employee">{resourcesString}</span></p>
                            </div>
                        </section>
                        {data?.proccess?.is_detached ? (
                            <div className="month-view-page__calendar__table__day__process--menu">
                                <img src={Lock} alt="menu" />
                            </div>
                        ) : null}
                        {!data?.proccess?.is_detached && data?.proccess?.should_occur_parallel ? (
                            <img
                                style={STYLE_PARALLEL_ICON_ABSOLUTE}
                                className="lock__icon"
                                src={ParallelIcon}
                                alt="parallel icon"
                            />
                        ) : null}
                    </div>
                    <div
                        style={infoPopupStyle}
                        className="info--popup"
                        id={data.proccess._id}
                    >
                        <InformationPopup
                            process={data?.proccess}
                            popupId={data.proccess._id}
                            data={data}
                        />
                    </div>
                </React.Fragment>
            )}
        </Draggable>
    )
}, (prevProps, nextProps) => {
    return (
        prevProps.data === nextProps.data &&
        prevProps.data.proccess === nextProps.data.proccess &&
        prevProps.data.warnings === nextProps.data.warnings &&
        prevProps.data.proccess?.done === nextProps.data.proccess?.done &&
        prevProps.data.proccess?.fraction === nextProps.data.proccess?.fraction &&
        prevProps.data.proccess?.is_detached === nextProps.data.proccess?.is_detached &&
        prevProps.day.parsedDate === nextProps.day.parsedDate &&
        prevProps.disableDrag === nextProps.disableDrag &&
        prevProps.isCurrentProcess === nextProps.isCurrentProcess &&
        prevProps.user_or_order_type === nextProps.user_or_order_type
    )
})

const DroppableRow = memo(({
    day,
    dataDay,
    userIndex,
    isHalfDayBlank,
    disableDrag,
    user_or_order_type,
    isCurrentProcess,
    handleProcessMenu,
    shouldRenderProcessOnThisDay,
    checkIndexAt,
    checkIndexAndSetWidth,
    getProcessBorderRadius,
    initHandlerForInfoPopup,
    closeHandlerInfoPopup
}) => {
    const processesForUser = useMemo(
        () => sortProcessesMonthlyView(dataDay.value),
        [dataDay.value]
    )

    const droppableStyle = useMemo(() => ({
        width: '100%',
        height: dataDay.heightWouldBe + 'px',
        borderBottom: dataDay.heightWouldBe > 0 ? '1px solid rgb(226 231 236)' : '',
    }), [dataDay.heightWouldBe])

    return (
        <Droppable
            droppableId={`${day.parsedDate}_${dataDay.key}`}
            key={`${day.parsedDate}_${dataDay.key}`}
        >
            {(provided, snapshot) => (
                <div
                    className="month-resource-page__calendar__table__day__droppable"
                    data-row={userIndex}
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{
                        ...droppableStyle,
                        background: snapshot.isDraggingOver ? '#e5e5e5' : 'transparent'
                    }}
                >
                    {!isHalfDayBlank ? (
                        <>
                            {processesForUser.map((data, Index) => (
                                <ProcessItem
                                    key={data.proccess._id + '_' + Index}
                                    data={data}
                                    day={day}
                                    userIndex={userIndex}
                                    Index={Index}
                                    i={Index}
                                    disableDrag={disableDrag}
                                    user_or_order_type={user_or_order_type}
                                    isCurrentProcess={isCurrentProcess}
                                    handleProcessMenu={handleProcessMenu}
                                    shouldRenderProcessOnThisDay={shouldRenderProcessOnThisDay}
                                    checkIndexAt={checkIndexAt}
                                    checkIndexAndSetWidth={checkIndexAndSetWidth}
                                    getProcessBorderRadius={getProcessBorderRadius}
                                    initHandlerForInfoPopup={initHandlerForInfoPopup}
                                    closeHandlerInfoPopup={closeHandlerInfoPopup}
                                />
                            ))}
                            {provided.placeholder}
                        </>
                    ) : (
                        <div className="month-resource-page__calendar__table__day--dayoff">
                            <p style={STYLE_DAY_OFF_P}>{day.holiday?.name}</p>
                        </div>
                    )}
                </div>
            )}
        </Droppable>
    )
}, (prevProps, nextProps) => {
    return (
        prevProps.day.parsedDate === nextProps.day.parsedDate &&
        prevProps.dataDay.key === nextProps.dataDay.key &&
        prevProps.dataDay.value === nextProps.dataDay.value &&
        prevProps.dataDay.heightWouldBe === nextProps.dataDay.heightWouldBe &&
        prevProps.isHalfDayBlank === nextProps.isHalfDayBlank &&
        prevProps.disableDrag === nextProps.disableDrag &&
        prevProps.isCurrentProcess === nextProps.isCurrentProcess &&
        prevProps.user_or_order_type === nextProps.user_or_order_type
    )
})

class MonthlyResourcesCalendar extends Component {

    constructor(props) {
        super(props)
        this.state = {
            infoPopup: false,
            processInfoData: {},
            infoPop: React.createRef(),
        }

        this.handleProcessMenu = this.handleProcessMenu.bind(this)
        this.initHandlerForInfoPopup = this.initHandlerForInfoPopup.bind(this)
        this.closeHandlerInfoPopup = this.closeHandlerInfoPopup.bind(this)
        this.shouldRenderProcessOnThisDay = this.shouldRenderProcessOnThisDay.bind(this)
        this.checkIndexAt = this.checkIndexAt.bind(this)
        this.checkIndexAndSetWidth = this.checkIndexAndSetWidth.bind(this)
        this.getProcessBorderRadius = this.getProcessBorderRadius.bind(this)

        this._headerColor = 'rgb(210 210 210)'
    }

    handleProcessMenu(data, date) {
        this.props.initProccessUpdatePopup(data, date)
    }

    goToDailyIfMobile = (day) => {
        const dynamicFactoryName = this.props.factoryName
        let dateNew = day.date
        dateNew = moment(dateNew).add(5, 'hours')._d
        this.props.history.push(`/${dynamicFactoryName}/daily/${dateNew} ${window.location.search}`)
    }

    setDayColor = (day) => {
        return day.warnings ? 'red' : 'rgba(0, 0, 0, 0.6)'
    }

    backToToday = () => {
        this.props.backToToday()
    }

    _lastDatesArrayForWarning = null
    _cachedMobileDaysWarning = []

    findDayWarningForMobileUiHeader = () => {
        const { datesArray } = this.props
        if (datesArray === this._lastDatesArrayForWarning) {
            return this._cachedMobileDaysWarning
        }
        this._lastDatesArrayForWarning = datesArray

        let mobile_days_names = []
        if (datesArray && datesArray.length > 0) {
            const dayNames = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת']
            mobile_days_names = dayNames.map(name =>
                datesArray.filter(day => day.dateName === name && day.warnings).length <= 0
            )
        }
        this._cachedMobileDaysWarning = mobile_days_names
        return mobile_days_names
    }

    previous_info_popup_id = ''

    initHandlerForInfoPopup(event, popup_id) {
        if (this.previous_info_popup_id) {
            let tag = document.getElementById(this.previous_info_popup_id)
            tag && (tag.style.display = 'none')
        }
        if (event.target.offsetParent.nextSibling) {
            document.getElementById(event.target.offsetParent.nextSibling.id).style.display = 'block'
        } else if (event.target.parentElement.nextSibling) {
            document.getElementById(event.target.parentElement.nextSibling.id).style.display = 'block'
        } else {
            document.getElementById(event.target.parentElement.parentNode.nextSibling.id).style.display = 'block'
        }
        if (popup_id) {
            let tag = document.getElementById(popup_id)
            tag && (tag.style.marginTop = this.setInfoTopView(event))
        }
        this.previous_info_popup_id = popup_id
    }

    setInfoTopView = (event) => {
        let yPoint = event.clientY
        let innerHeight = window.innerHeight
        let height = innerHeight - yPoint
        return (height < 160) ? '-78%' : '-12%'
    }

    closeHandlerInfoPopup(event, popup_id) {
        let is_hover_on_info = false
        document.getElementById(popup_id)?.addEventListener('mouseenter', () => {
            is_hover_on_info = true
        }, false)
        setTimeout(() => {
            if (!is_hover_on_info) {
                const el = document.getElementById(popup_id)
                if (el) el.style.display = 'none'
            }
        }, 100)
    }

    fourWeeksDateChangeCal = (value) => {
        this.props.fourWeeksDateChange(value)
    }

    checkIndexAt(date, data) {
        const { original_process_duration = 1, zindex = false } = data.proccess || {}
        return original_process_duration > 1 ? true : zindex
    }

    handleCurrentDayBackgroundColor(currentDate) {
        const today = new Date()
        const formattedDate = moment(today).format("DD/MM/YYYY")
        return currentDate === formattedDate
    }

    checkIndexAndSetWidth(index, data) {
        let { original_process_width = 1 } = data.proccess || {}
        return `calc(((100% + 0.1px) * ${original_process_width}) - 3px)`
    }

    getProcessBorderRadius(process) {
        if (!process) return '20px'
        return '20px'
    }

    shouldRenderProcessOnThisDay(process, currentDayDate) {
        if (!process || !currentDayDate) return false

        if (process.isSegment || process.isFirstSegment) return true

        const processStartDate = moment(process.process_date).format('DD/MM/YYYY')
        const currentDate = moment(currentDayDate).format('DD/MM/YYYY')

        return processStartDate === currentDate
    }

    render() {
        const { daysOffNumber, disableDrag, daysOff, user_or_order_type } = this.props
        let { datesArray } = this.props
        if (!Array.isArray(datesArray)) {
            datesArray = []
        }

        let headerDatesString = datesArray && datesArray.length > 0
            ? datesArray[0].parsedDate + ' - ' + datesArray[datesArray.length - 1].parsedDate
            : null
        let headerWeeksFirstString = datesArray && datesArray.length > 0
            ? moment(datesArray[0].date).week()
            : null
        let headerWeeksEndString = datesArray && datesArray.length > 0
            ? moment(datesArray[datesArray.length - 1].date).week()
            : null

        let mobile_days_names_warning_check = this.findDayWarningForMobileUiHeader()
        let mobileDaysNames = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת']
        const header_color = this._headerColor

        let blockDecrementation = false

        const dayColWidthStyle = { width: `calc( 100% / ${8 - daysOffNumber})` }
        const mobilePanelWidthStyle = { width: `calc( 100% / ${7 - daysOffNumber})` }
        const userColWidthStyle = { width: `calc( 100% / ${8 - daysOffNumber})` }

        const stickyHeaderStyleNormal = { marginBottom: '5px' }
        const headerBgNormal = { backgroundColor: header_color, justifyContent: 'center' }
        const headerBgGreen = { backgroundColor: '#cef8c1', justifyContent: 'center' }
        const headerBgNormalDay = { backgroundColor: header_color }
        const headerBgGreenDay = { backgroundColor: '#cef8c1' }

        return (
            <div className="month-resource-page__calendar">

                <header className="month-resource-page__calendar__header">
                    <figure id="mobile__dec__figure" style={blockDecrementation ? { pointerEvents: 'none' } : undefined} onClick={() => { this.fourWeeksDateChangeCal('dec') }}>
                        <img className="monthly-resource-arrows" src={caretRight} alt="right-arrow" />
                    </figure>
                    <button className="btn--back--today" onClick={() => { this.backToToday() }}>
                        <SvgIcon className="back--today--icon" component={EventIcon} />
                        <p>חזור להיום</p>
                    </button>
                    <figure className="figure-arrows" style={blockDecrementation ? { pointerEvents: 'none' } : undefined} onClick={() => { this.fourWeeksDateChangeCal('dec') }}>
                        <img className="monthly-resource-arrows" src={caretRight} alt="right-arrow" />
                    </figure>
                    {!!(headerDatesString) && <h3>שבועות {headerWeeksFirstString} - {headerWeeksEndString} ( {headerDatesString} )</h3>}
                    <figure className="figure-arrows" onClick={() => { this.fourWeeksDateChangeCal('inc') }}>
                        <img className="monthly-resource-arrows" src={caretLeft} alt="left-arrow" />
                    </figure>
                </header>

                <section className="month-resource-page__calendar__mobile-days-panel">
                    {mobileDaysNames.map((day, dayIndex) => {
                        if (!daysOff.includes(dayIndex))
                            return (
                                <div key={dayIndex} style={mobilePanelWidthStyle}>
                                    {mobile_days_names_warning_check[dayIndex] ?
                                        <p>{day}</p> :
                                        <p className="mobile__days__names__warning">{day} <img src={problem_icon} alt="problem" /></p>
                                    }
                                </div>
                            )
                        return null
                    })}
                </section>

                <section className="month-resource-page__calendar__table">
                    {(datesArray || []).map((day, ind) => {
                        let hasWarnings = false
                        let isUserIndex = false
                        if ((ind % 7) === 0) isUserIndex = true
                        let isHalfDayBlank = false
                        if (day.holiday && day.dayData.length === 0) isHalfDayBlank = true

                        for (let i = 0; i < day.dayData.length; i++) {
                            if (day.dayData[i]?.warnings?.length > 0 && !day.dayData[i].proccess.backlog) {
                                hasWarnings = true
                                break
                            }
                        }

                        let mobileParsedDate = day.parsedDate
                        mobileParsedDate = mobileParsedDate.substr(0, 5) + '/' + mobileParsedDate.substr(8)
                        let today_date = moment().format('L')
                        today_date = today_date.substr(0, 5) + '/' + today_date.substr(8)

                        if (!day.dayOff) {
                            const sortedData = memoSortMonthlyRView(day.parsedDate, day.dayData)
                            const isToday = this.handleCurrentDayBackgroundColor(day.parsedDate)
                            const dayCellStyle = isToday
                                ? { ...dayColWidthStyle, background: 'rgb(225,225,225)' }
                                : dayColWidthStyle

                            const dayColor = this.setDayColor(day)
                            const stickyHeaderStyleWithColor = dayColor !== 'rgba(0, 0, 0, 0.6)'
                                ? { marginBottom: '5px', color: dayColor }
                                : stickyHeaderStyleNormal

                            return (
                                <React.Fragment key={`${day.parsedDate}_${ind}`}>

                                    {isUserIndex && (
                                        <div
                                            key={`header_${day.parsedDate}`}
                                            style={userColWidthStyle}
                                            className={hasWarnings
                                                ? "month-resource-page__calendar__table__day month-resource-page__calendar__table__day--warning"
                                                : "month-resource-page__calendar__table__day"
                                            }
                                        >
                                            <figure></figure>

                                            <div className='sticky_header' style={stickyHeaderStyleNormal}>
                                                <header style={day.dayOff ? headerBgGreen : headerBgNormal}>
                                                    <p style={{ fontSize: '17px', fontWeight: 500, color: 'rgb(36, 55, 72)', textTransform: 'capitalize' }}>משתמשים</p>
                                                </header>
                                            </div>

                                            {day.holiday?.status === "Day Off" || day.dayOff ? (
                                                <React.Fragment>
                                                    <div className="month-resource-page__calendar__table__day--dayoff">
                                                        <p style={STYLE_DAY_OFF_P}>{day.holiday?.name}</p>
                                                        <p style={STYLE_DAY_OFF_P}>יום חופש</p>
                                                    </div>
                                                </React.Fragment>
                                            ) : (
                                                <div
                                                    className="month-resource-page__calendar__table__day__droppable"
                                                    style={{ height: day.holiday ? 'calc(100% - 50px)' : 'calc(100% - 30px)' }}
                                                >
                                                    {sortedData.map((dataDay, userIndex) => {
                                                        if (dataDay !== undefined) {
                                                            // PERF: Stable key using dataDay.key (not array index)
                                                            const rowStyle = {
                                                                width: '100%',
                                                                height: dataDay.heightWouldBe + 'px',
                                                                borderBottom: dataDay.heightWouldBe > 0
                                                                    ? '1px solid rgb(226 231 236)'
                                                                    : '',
                                                            };
                                                            return (
                                                                <div
                                                                    key={dataDay.key}
                                                                    style={{
                                                                        ...rowStyle
                                                                    }}
                                                                    data-resource-id={dataDay.key}
                                                                    data-row={userIndex + 1}
                                                                    className='mainResourceDiv'
                                                                >
                                                                    <h3 style={{ fontSize: '16px', fontWeight: 100, color: dataDay.overloaded ? 'red' : '#243748', textAlign: 'center' }}>
                                                                        {dataDay?.user_name}
                                                                    </h3>
                                                                </div>
                                                            )
                                                        }
                                                        return null
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    <div
                                        style={dayCellStyle}
                                        className={hasWarnings
                                            ? "month-resource-page__calendar__table__day month-resource-page__calendar__table__day--warning"
                                            : "month-resource-page__calendar__table__day"
                                        }
                                        key={day.parsedDate}
                                    >
                                        <figure></figure>

                                        {day.holiday?.status === "Day Off" || day.dayOff ? (
                                            <div style={stickyHeaderStyleWithColor} className='sticky_header'>
                                                <header style={headerBgGreenDay}>
                                                    <p>{day.dateName} {dayColor === 'red' ? <img className="warning_icon" src={Warning} alt="warning" /> : ""}</p>
                                                    <p><span title={day.holiday?.name}>{'(יום חופש) '}</span> {day.parsedDate}</p>
                                                    <span className={String(mobileParsedDate) === String(today_date) ? "today__mark" : ""}>{mobileParsedDate}</span>
                                                </header>
                                            </div>
                                        ) : day.holiday?.status === "Half Day" ? (
                                            <div style={stickyHeaderStyleWithColor} className='sticky_header'>
                                                <header style={headerBgGreenDay}>
                                                    <p>{day.dateName} {dayColor === 'red' ? <img className="warning_icon" src={Warning} alt="warning" /> : ""}</p>
                                                    <p><span title={day.holiday?.name}>{'(חצי יום)'}</span> {day.parsedDate}</p>
                                                    <span className={String(mobileParsedDate) === String(today_date) ? "today__mark" : ""}>{mobileParsedDate}</span>
                                                </header>
                                            </div>
                                        ) : (
                                            <div style={stickyHeaderStyleWithColor} className='sticky_header'>
                                                <header style={headerBgNormalDay}>
                                                    <p>{day.dateName} {dayColor === 'red' ? <img className="warning_icon" src={Warning} alt="warning" /> : ""}</p>
                                                    <p><span>{'(' + moment(day.date).week() + ') '}</span> {day.parsedDate}</p>
                                                    <span className={String(mobileParsedDate) === String(today_date) ? "today__mark" : ""}>{mobileParsedDate}</span>
                                                </header>
                                            </div>
                                        )}

                                        {day.holiday?.status === 'Day Off' || day.dayOff ? (
                                            <React.Fragment>
                                                <div className="month-resource-page__calendar__table__day--dayoff">
                                                    <p style={STYLE_DAY_OFF_P}>{day.holiday?.name}</p>
                                                </div>
                                            </React.Fragment>
                                        ) : (
                                            <>
                                                {sortedData.map((dataDay, userIndex) => {
                                                    if (dataDay !== undefined) {
                                                        return (
                                                            <DroppableRow
                                                                // PERF: Stable key — no array index suffix
                                                                key={`${day.parsedDate}_${dataDay.key}`}
                                                                day={day}
                                                                dataDay={dataDay}
                                                                userIndex={userIndex}
                                                                isHalfDayBlank={isHalfDayBlank}
                                                                disableDrag={disableDrag}
                                                                user_or_order_type={user_or_order_type}
                                                                isCurrentProcess={this.props.isCurrentProcess}
                                                                handleProcessMenu={this.handleProcessMenu}
                                                                shouldRenderProcessOnThisDay={this.shouldRenderProcessOnThisDay}
                                                                checkIndexAt={this.checkIndexAt}
                                                                checkIndexAndSetWidth={this.checkIndexAndSetWidth}
                                                                getProcessBorderRadius={this.getProcessBorderRadius}
                                                                initHandlerForInfoPopup={this.initHandlerForInfoPopup}
                                                                closeHandlerInfoPopup={this.closeHandlerInfoPopup}
                                                            />
                                                        )
                                                    }
                                                    return null
                                                })}
                                            </>
                                        )}
                                    </div>
                                </React.Fragment>
                            )
                        }
                        return null
                    })}
                </section>
            </div>
        )
    }
}

function mapStateToProps({ monthResource, generalReducers }) {
    return {
        monthResource,
        draggingDestination: generalReducers.draggingDestination
    }
}
export default connect(mapStateToProps, actions)(MonthlyResourcesCalendar)